import React from "react";
import { observer } from "mobx-react";
import IconButton from "../../comum/components/IconButton";
import moment from "moment";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";

@observer
export default class ExportarExcelCargaGeral extends React.Component {
  constructor(props) {
    super(props);
    this.controller = this.props.controller;
  }

  _exporter;
  export = () => {
    this._exporter.save();
  };


  formatData = (data) => {
    return data.map((item) => {
      const formattedItem = { ...item };
      Object.keys(formattedItem).forEach((key) => {
        if (
          key.includes("Format") &&
          moment(formattedItem[key.replace("Format", "")]).format(
            "DD/MM/YYYY HH:mm"
          ) !== "Invalid date"
        ) {
          formattedItem[key.replace("Format", "")] = moment(
            formattedItem[key.replace("Format", "")]
          ).format("DD/MM/YYYY HH:mm");
        }
      });
      if (
        formattedItem.DataCancelamento &&
        formattedItem.DataCancelamento.startsWith("0001-01-01")
      ) {
        formattedItem.DataCancelamento = "";
      }
      return formattedItem;
    });
  };

  render() {

    const desabilita = this.controller.cargasLista === 0;
    
    const listaFormatada = this.formatData(this.controller.cargasLista);
    const selecionadosFormatados = this.formatData(this.controller.selecionados);

    let cols = this.controller.colunasExportacao;

    return (
      <div>
        <IconButton
          icon="file-excel"
          text="Baixar XLS"
          size="md"
          disabled={desabilita}
          onClick={this.export}
        />
        {this.controller.selecionados.length > 0 ? (
          <ExcelExport
            data={selecionadosFormatados}
            fileName="CargasGerais.xlsx"
            ref={(exporter) => {
              this._exporter = exporter;
            }}
          >
            {cols.map((coluna, x) => (
              <ExcelExportColumn
                key={x}
                title={coluna.text}
                field={coluna.dataField}
              />
            ))}
          </ExcelExport>
        ) : (
          <ExcelExport
            data={listaFormatada}
            fileName="CargasGerais.xlsx"
            ref={(exporter) => {
              this._exporter = exporter;
            }}
          >
            {cols.map((coluna, x) => (
              <ExcelExportColumn
                key={x}
                title={coluna.text}
                field={coluna.dataField}
              />
            ))}
          </ExcelExport>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/ExportarExcelCargaGeral.js